import { createContext, useContext } from 'react'

export const ImageCardContext = createContext<{ hasImage: boolean }>({ hasImage: false })

export function useImageCardHasImage() {
  return useContext(ImageCardContext).hasImage
}
